<template >
  <v-toolbar flat color="">    
    <v-toolbar-title class="title mr-7 hidden-sm-and-down">
      
    </v-toolbar-title>
    <v-spacer >    </v-spacer>
    <v-autocomplete
      align="center"
      
      color="white"
      full-width
      id="searcher"
      dense
      rounded
      v-model="model"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      append-icon=""
      chips
      clearable
      :disabled="!idPresent"
      hide-details
      hide-selected
      item-text="title"
      :item-value="getter"
      label="Search..."
      solo
      
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            Search for your favorite
            <strong>content in the knowledge base</strong>
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:selection="{ attr, on, item, selected }">
        <v-chip
          v-bind="attr"
          :input-value="selected"
          color="blue-grey"
          class="white--text"
          v-on="on"
        >
          <v-icon left>
            mdi-book-play
          </v-icon>
          <span v-text="item.title"></span>
        </v-chip>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-avatar
          color="indigo"
          class="headline font-weight-light white--text"
        >
          {{ item.title.charAt(0) }}
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="item.title"></v-list-item-title>
          <v-list-item-subtitle v-text="item.description"></v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon>{{computedIcon(item.type)}}</v-icon>
        </v-list-item-action>
      </template>
    </v-autocomplete>
    <template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="340" 
    >
      <v-card>
        <v-toolbar
              color="primary"
              dark
            >Open {{dialogTitle}}?</v-toolbar>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="openContent"
            ref="dialogOpenContent"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
  </v-toolbar>
  
</template>
<script> 

/*      document.addEventListener("keydown", (e) => {
        console.log(e)
        if(e.key=="/"){
          e.preventDefault()
          document.getElementById("searcher").focus()
          
        }
    });
  */

import { gql } from '@apollo/client/core';
  export default {
    data: () => ({
      dialog: false,
      isLoading: false,
      items: [],
      model: null,
      search: null,
      tab: null,
    }),
    mounted() {
      document.addEventListener("keydown", (e) => {        
        if(this.mode!="development"){
          if(e.key=="/"){
            e.preventDefault()
            document.getElementById("searcher").focus()
          }
        }
      });
    },
    props: ['client', 'kb_id', 'mode'],
    computed: {
      id(){
        if(this.$route.params.id!=undefined){
          return this.$route.params.id
        }else if(this.kb_id!=''){
          return this.kb_id
        }else{
          return undefined
        }
      },
      idPresent(){
        //Covers disabling the search bar during kb creation before it is autosaved
        if(this.kb_id=='' && this.$route.params.id==undefined){
          return false
        }else{
          return true
        }
      },
      dialogTitle(){
        if(this.model){
          return this.model.title
        }else{
          return ""
        }
      }
    },
    methods: {
      queryForKeywords(event) {
        alert('booya')
        console.log("This mode is :", this.mode)
        if(this.mode!="development"){
          if(event.key=="/"){
            event.preventDefault()
            document.getElementById("searcher").focus()
          }
        }
      },
      computedIcon(type){
      if(type=="tutorial"){
        return 'mdi-book-play'
      }else if (type=='quiz'){
        return 'mdi-check-decagram-outline'
      }else{
        return "mdi-flag"
      }
    },
      getter(val){
        //console.log(val.description)
        return val
      },
      openContent(){
        this.dialog=false
        if(this.model.type!=undefined){
            window.open(`/kbs/v/${this.$route.params.id}/${this.model.parent_category_id}/${this.model.id}`)
        }else{
          window.open(`/kbs/kb/${this.model.id}`)
        }
      },
      customFilter (item, queryText, itemText) {
        console.log("itemText is ", itemText)
        const textOne = item.title.toLowerCase()
        const textTwo = item.description.toLowerCase()
        const searchText = queryText.toLowerCase()

        return textOne.indexOf(searchText) > -1 ||
          textTwo.indexOf(searchText) > -1
      },
    
    querySelections(val){
      let id=this.id;
      if(!id){
        console.log("KnowledgeBase id is not present. Exiting.")
        return
      }
      console.log("id ", id)
      console.log("Val", val)
        this.client
          .query({
            query: gql`
              query searchers($path: uuid!) {
                knowledge_base_by_pk(id: $path) {
                  id
                  title
                  description
                  categories{
                    category{
                      id
                      title
                      description
                      content
                    }
                  }
                }
              }
            `,
            variables: {
              path: id
            },
          }).then(result => {
            console.log(result)
            let kb=result.data.knowledge_base_by_pk
            console.log("Bubba", kb.categories)
            let holdMatches=[]
            kb.categories.forEach(category=>{
              if(category.category_id!="bubba"){
                  let matchItem={}
                  matchItem.id=category.category_id
                  matchItem.title=category.category.title
                  matchItem.description=category.category.description
                  console.log("matchitem", matchItem)
                  matchItem.type="Category"
                  holdMatches.push(matchItem)
                  console.log("Adding category content:", matchItem.title, matchItem.type)
                  category.category.content.forEach(contenter=>{
                    let contentMatch={}
                    contentMatch.parent_category_id=category.category.id
                    contentMatch.parent_category_title=category.category.title
                    contentMatch.parent_knowledge_base_id=kb.id
                    contentMatch.parent_knowledge_base_title=kb.title
                    contentMatch.id=contenter.id;
                    contentMatch.title=contenter.title
                    contentMatch.type=contenter.type;
                    //Add this to the object being saved in the jsonb column
                    contentMatch.description=contenter.title
                    console.log("Adding content:", contentMatch.title, contentMatch.type)
                    holdMatches.push(contentMatch)
                  })
              }
              this.items=holdMatches
            })
          }).finally(() => (this.isLoading = false))
    }
    },
    watch: {
      dialog() {
        if (!this.dialog) return
          requestAnimationFrame(() => {
            this.$refs.dialogOpenContent.$el.focus()
          })
      },
      model (val) {
        if (val != null) {
          this.dialog=true
        }
        else {
          this.tab = null
          this.items=[]
          console.log("model is null, clearing items")
        }
      },
      search (val) {
        val && val !== this.model && this.querySelections(val)
      }, 
    }
  }
</script>
